/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Divider, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import StyledOrderHistoryCard from "./StyledOrderHistoryCard";
import { fetchStatus } from "../../store/reducers/bag/apiThunk";
import { useDispatch } from "react-redux";
import { ToastNotifyError } from "../../components/CommonComponents/Toast/ToastNotify";
import deliveredIcon from "../../assets/icons/deliveredIcon.svg";
import cancelledIcon from "../../assets/icons/cancelledIcon.svg";
import inProcessIcon from "../../assets/icons/processingIcon.svg";
import { ROUTE_PATH } from "../../constants/route";
import { useNavigate } from "react-router-dom";
import noDataIcon from "../../assets/icons/shoppingBag.svg";

const {ORDER_HISTORY_DETAILS} = ROUTE_PATH;

const OrderHistoryCard = ({ data }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [colorData, setColorData] = useState([]);

  const fetchStatusData = async () => {
    try {
      const response = await dispatch(fetchStatus());
      const { data, status } = response?.payload;
      if (status) {
        setColorData(data);
      }
    } catch {
      ToastNotifyError("Failed to fetch status color");
    }
  };

  useEffect(() => {
    fetchStatusData();
  }, []);

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  };

  const StatusTags = (status) => {
    const getStatus = (status) => {
      const matchedObject = colorData?.find(
        (item) => item?.value?.toLowerCase() === status?.toLowerCase()
      );
      if (!matchedObject) return null;
      return matchedObject;
    };

    return (
      <Box
        sx={{
          backgroundColor: getStatus(status)?.background_color,
          color: getStatus(status)?.text_color,
          padding: "2px 7px",
          borderRadius: "20px",
          fontSize: "11px",
          fontWeight: 500,
          textTransform: "uppercase",
          fontFamily: "Lexend",
        }}
      >
        {getStatus(status)?.label}
      </Box>
    );
  };



  return (
    <StyledOrderHistoryCard>
      {data.length > 0 ? data?.map((item, index) => {
        return (
          <Box className='order-history-card-wrap' key={index}>
            <Box className='order-history-headings'>
              <Box className='order-history-heading-order'>
                <Typography className='order-id'>
                  {`Order Id #${item?.order_number}`}{" "}
                </Typography>
                <Typography className='order-items-count'>{`${item?.order_items?.length} piece${item?.order_items?.length > 1 ? "(s)" : ""}`}</Typography>
              </Box>
              <Box className='order-history-heading-date'>
                <Typography className="order-date">{formatDate(item?.created_at)}</Typography>
              </Box>
            </Box>
            <Box className='order-history-card-body'>
              <Box className='order-history-card-body-wrap'>
                <Typography className='order-history-card-body-status'>
                  {StatusTags(item?.status)}
                </Typography>
                <Typography className='order-history-card-body-price'>
                  {`$${item?.total}`}
                </Typography>
              </Box>
              <Box className='order-history-card-body-delivery'>
                <Box
                  className='delivery-icon-wrap'
                  sx={{
                    bgcolor: 'unset !important',

                  }}
                >
                  <Box
                    component="img"
                    sx={{
                      width: '24px !important',
                      height: '24px !important',
                      objectFit: 'contain',
                    }}
                    className='delivery-icon'
                    src={item?.status === "COMPLETED" ? deliveredIcon : item?.status === "CANCELLED" ? cancelledIcon : inProcessIcon}
                    alt='Delivery icon'
                  />
                </Box>
                <Typography className="order-history-card-body-delivery-date">
                  {`${item?.status === "COMPLETED" ? "Delivered on" : item?.status === "CANCELLED" ? "Cancelled on" : "Delivery on"} ${formatDate(item?.shipping_address?.arrival_date)}`}
                  </Typography>
              </Box>
              <Divider />
              <Box className='order-history-card-body-product'>
                {item?.order_items?.map((order_item, index) => {
                  return (
                    <>
                      <Box
                        className='order-history-card-body-product-wrap'
                        key={index}
                      >
                        <Box className='order-history-product-name'>
                          <Box className='order-history-card-body-product-image'>
                            <img
                              src={order_item?.product_image[0]}
                              alt=''
                              className='product-image'
                            />
                          </Box>
                          <Box className='order-history-card-body-product-details'>
                            <Typography className='order-history-card-body-product-name'>
                              {order_item?.product_name}
                            </Typography>
                            <Box className='order-history-card-body-product-details-size'>
                              <Box className='order-history-size'>
                                Size: {order_item?.size}
                              </Box>
                              <Box className='order-history-size'>
                                Qty: {order_item?.quantity}
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                        <KeyboardArrowRightIcon onClick={() => navigate(ORDER_HISTORY_DETAILS, { state: { orderData: item } })} sx={{ cursor: "pointer" }} />
                      </Box>
                      <Box className='divider-wrap'>
                        {index !== item?.order_items?.length - 1 && <Divider sx={{borderStyle: 'dashed'}} />}
                      </Box>
                    </>
                  );
                })}
                <Box className='order-product-view-details-wrap'>
                  <Typography className='order-product-view-details' onClick={() => navigate(ORDER_HISTORY_DETAILS, { state: { orderData: item } })}>
                    View Order Details
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        );
      }) : 
      <Box className='nodata-container'>
        <Box className='nodata-icon-box'>
           <img src={noDataIcon} alt="" />
        </Box>
        <Typography className="nodata-title">You have no orders yet</Typography>
        <Typography className="nodata-subtitle">Buy now to keep track of your orders</Typography>
        <Box className="nodata-button" onClick={() => navigate(ROUTE_PATH.BROWSE)}>Shop now</Box>
        
      </Box>}
    </StyledOrderHistoryCard>
  );
};

export default OrderHistoryCard;
